<template>
    <div>
        <h3>Scegli l'obiettivo</h3>
        <p>Seleziona gli obiettivi</p>

        <div class="d-flex gap-3 flex-wrap my-6">
            <summary v-for="(obiettivo, i) in obiettivi" :key="'ob_' + i"
                class="d-inline-flex flex-column align-items-center text-center mw-90 minw-90 gy-4 mb-3 p-2" 
                :class="tagClass(obiettivo)" @click="selectObiettivi(obiettivo, i)">
                <img class="mw-40 w-100" :src="obiettivo.icon" :alt="obiettivo.name" />
                <span class="fs-xxs font-alt ls-wide text-uppercase mt-auto text-break" v-html="obiettivo.name"></span>
            </summary>
        </div>

        <div class="d-flex justify-content-center justify-content-md-start">
            <button 
                class="steplink stepback btn btn-secondary me-2"
                @click="backStep" 
                >Indietro</button>
            <button 
                class="steplink stepnext btn btn-primary"
                    :disabled="canGoNext"

                @click="nextStep" 
                >Continua</button>
        </div>        
    </div>
</template>

<script>
import {  isNil, isEmpty, find, union } from "lodash";

export default {
    name: 'ObiettiviStep',
    data() {
        return {
            obiettivi: this.$store.state.obiettivi,
            selected: this.$store.getters.obiettivi_active
        }
    },
    props: {
        direction: String
    },
    computed: {
        canGoNext() {
            return !this.$store.getters.obiettivi_active.length;
        }
    },
    created() {
        this.log('obiettivi',this.obiettivi);
        this.log('obiettivi sel', this.selected);
        if( isEmpty(this.selected) )
            return;
        
        const obiettivi = this.obiettivi;
        obiettivi.forEach((obiettivo) => {
            // this.log('ciclo obiettivo', parseInt(obiettivo.id));
            if(!isNil(find(this.selected, function (o) { return parseInt(o) === parseInt(obiettivo.id); }))){
                obiettivo.isActive = true;
            }else{
                obiettivo.isActive = false;
            }
            obiettivo.show = false;
        });

    }, 
    async beforeMount(){
        this.obiettivi.forEach((obiettivo) => {
            const image = new Image();
            image.loading = "lazy";
            image.src = obiettivo.icon;
        });
    },
    mounted() {
        this.GTM_trackView("Step obiettivi", "/abbonamento#step3");
    },
    methods: {
        
        backStep() {
            this.$emit("update", {
                back: true
            });
            return;
        },
        nextStep() {
            
            this.$store.commit("setStore", { obiettivi: this.selected });
            this.$emit("update", {
                next: true
            });
        },
        tagClass(tag) {
            const isSelected = tag.isActive;

            return {
                'active': isSelected,
                'not-active': !isSelected
            }
        },
        selectObiettivi: async function (obiettivo, i) {
            const index = this.selected.findIndex(t => t == obiettivo.id)
            const tmpOb = this.obiettivi[i];
            // se non è presente aggiungo
            if(index < 0){
                this.selected = union([obiettivo.id], this.selected);
                tmpOb.isActive = true;
            }else{
                // altrimenti rimuovo
                this.selected.splice(index, 1);
                tmpOb.isActive = false;
            }
            this.$set(this.obiettivi, i, tmpOb);
            await this.$nextTick();
        }
    },
    watch: {
        selected: {
            handler(val) {
                this.$store.commit("setStore", { obiettivi: val });
                this.log(this.$store.getters.obiettivi_active);
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../../themes/tls-theme/src/scss/variables";
    
summary:hover{
    border-color: $primary !important;
}
</style>